// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__ICtCc","list":"BalanceDue_list__1YQ88","listRow":"BalanceDue_listRow__3rfVU","total":"BalanceDue_total__2T3io"};